// Consts
export const LANGUAGE_SELECTED = '[LANGUAGE] Selected';

export const switchLanguage = language => dispatch => {
  document.documentElement.setAttribute('lang', language.toLowerCase());
  dispatch({ type: LANGUAGE_SELECTED, language });
};
